var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("form", [
      _c("h2", [_vm._v("Account Additional Details")]),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel-grey" }, [
        _c("div", { staticClass: "panel-body" }, [
          _c("div", { staticClass: "form-horizontal" }, [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.user.custom_fields, function (field, index) {
                return _c(
                  "div",
                  {
                    key: field.name,
                    class: _vm.hasErrorClass(
                      _vm.$v.user.custom_fields[index].value,
                      "form-group col-xs-12 col-lg-12"
                    ),
                  },
                  [
                    field.dataType === "url"
                      ? _c(
                          "label",
                          { staticClass: "control-label col-xs-2 col-lg-2" },
                          [_vm._v("URL Link")]
                        )
                      : _c(
                          "label",
                          { staticClass: "control-label col-xs-2 col-lg-2" },
                          [_vm._v(_vm._s(field.name))]
                        ),
                    _vm._v(" "),
                    field.dataType === "text" || field.dataType === undefined
                      ? _c("div", { staticClass: "col-xs-10 col-lg-10" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.$v.user.custom_fields[index].value.$model,
                                expression:
                                  "$v.user.custom_fields[index].value.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", maxlength: "1024" },
                            domProps: {
                              value:
                                _vm.$v.user.custom_fields[index].value.$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.user.custom_fields[index].value,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    field.dataType === "url"
                      ? _c("div", { staticClass: "col-xs-10 col-lg-10" }, [
                          _c("div", { staticClass: "alert alert-primary" }, [
                            _c(
                              "a",
                              { attrs: { href: field.name, target: "_blank" } },
                              [_vm._v(_vm._s(field.name))]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    field.dataType === "file"
                      ? _c(
                          "div",
                          { staticClass: "col-xs-10 col-lg-10" },
                          [
                            _c("file-input", {
                              attrs: { prefix: "user-custom-fields" },
                              model: {
                                value:
                                  _vm.$v.user.custom_fields[index].value.$model,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.$v.user.custom_fields[index].value,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.user.custom_fields[index].value.$model",
                              },
                            }),
                          ],
                          1
                        )
                      : field.dataType === "date"
                      ? _c("div", { staticClass: "col-xs-10 col-lg-10" }, [
                          _c(
                            "div",
                            { staticClass: "calendar-group" },
                            [
                              _c("flat-pickr", {
                                staticClass: "form-control pickdate",
                                attrs: {
                                  config: _vm.flatPickerSingleDateConfig,
                                  name: "date",
                                },
                                model: {
                                  value:
                                    _vm.$v.user.custom_fields[index].value
                                      .$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.user.custom_fields[index].value,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.user.custom_fields[index].value.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : field.dataType === "dropdown"
                      ? _c(
                          "div",
                          { staticClass: "col-xs-10 col-lg-10" },
                          [
                            _c("selectize", {
                              staticClass: "selectize selectize-single w-full",
                              attrs: {
                                name: "timezone",
                                options: _vm.getListOptions(field.listOptions),
                              },
                              model: {
                                value:
                                  _vm.$v.user.custom_fields[index].value.$model,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.$v.user.custom_fields[index].value,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression:
                                  "$v.user.custom_fields[index].value.$model",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("vuelidate-help", {
                      attrs: {
                        field: _vm.$v.user.custom_fields[index].value,
                        label: field.name,
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-footer" },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-sm btn-primary",
                attrs: {
                  type: "submit",
                  click: _vm.handleUpdateDetails,
                  disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
                },
              },
              [_vm._v("Save Changes")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }